import React from 'react';
import PropTypes from 'prop-types';

const EmptystateButton = ({ onClick, children }) => (
  <button
    className="w-full border flex-wrap flex justify-center py-4 bg-slate-50 cursor-pointer group hover:bg-slate-100"
    onClick={onClick}
    type="button"
  >
    {children}
  </button>
);

EmptystateButton.defaultProps = {
  onClick: () => {},
};

EmptystateButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
};

export default EmptystateButton;
